import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Container,
  Typography,
  Grid,
  TextField,
  Button,
  RadioGroup,
  FormControlLabel,
  Radio,
  Checkbox,
  Snackbar,
  Alert,
  FormControl,
  InputLabel,
  Select,
  MenuItem
} from "@mui/material";
import jsPDF from "jspdf";
import autoTable from 'jspdf-autotable';
import companyLogo from '../data/pmlogo-removebg-preview.png'
import axios from "axios";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
const paintTypes = [
  { label: "Royal Emulsion", cost: 220, coverage: 140 },
  { label: "Distemper", cost: 120, coverage: 100 },
  { label: "Putty", cost: 70, coverage: 80 },
  { label: "Primer", cost: 100, coverage: 90 },
];



const PaintCalculator = () => {
  const [projectType, setProjectType] = useState("");
  const [spaceType, setSpaceType] = useState("");
  const [area, setArea] = useState(0);
  const [allPaints, setAllpaints] = useState([]);
  const [paintType, setPaintType] = useState("");
  const [puttyCoats, setPuttyCoats] = useState(1);
  const [paintCoats, setPaintCoats] = useState(2);
  const [includeLabor, setIncludeLabor] = useState(false);
  const [result, setResult] = useState(null);
  const [showResetMsg, setShowResetMsg] = useState(false);

  const pdfRef = useRef();

  const canSizes = [20, 10, 4, 1];

  const handleCalculate = () => {
    const selected = allPaints.find((p) => p.name === paintType);
    if (!selected || area <= 0) return;

    const paintRequired = Math.ceil((area * paintCoats) / selected.estimatedCoverage);
    const costPerLiter = includeLabor ? selected.priceWithLabor : selected.priceWithoutLabor;
    const paintCost = paintRequired * costPerLiter;
    const puttyCost = puttyCoats * area * 6;
    const laborCost = includeLabor ? area * 8 : 0;
    const total = paintCost + puttyCost + laborCost;
    const gst = Math.round(total * 0.18);
    const grandTotal = total + gst;
    const costPerSqft = (grandTotal / area).toFixed(2);

    const suggestedCans = {};
    let remaining = paintRequired;
    canSizes.forEach((size) => {
      if (remaining >= size) {
        const count = Math.floor(remaining / size);
        suggestedCans[size] = count;
        remaining -= count * size;
      }
    });
    if (remaining > 0) suggestedCans[1] = (suggestedCans[1] || 0) + 1;

    setResult({
      litres: paintRequired,
      paintCost,
      puttyCost,
      laborCost,
      total,
      gst,
      grandTotal,
      costPerSqft,
      suggestedCans,
    });
  };

  const handleReset = () => {
    setProjectType("");
    setSpaceType("");
    setArea(0);
    setPaintType("");
    setPuttyCoats(1);
    setPaintCoats(2);
    setIncludeLabor(false);
    setResult(null);
    setShowResetMsg(true);
  };

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_MY_API}/api/products/686154b5cbe093c404c97c5b`).then((res) => {
      setAllpaints(res.data);
    });
  }, []);

  const downloadPDF = () => {
    const doc = new jsPDF();
    const date = new Date().toLocaleDateString();
    const selected = allPaints.find((p) => p.name === paintType);
    const rate = includeLabor ? selected?.priceWithLabor : selected?.priceWithoutLabor;

    const paintRequired = Math.ceil((area * paintCoats) / selected.estimatedCoverage);
    const paintCost = paintRequired * rate;
    const puttyCost = puttyCoats * area * 6;
    const laborCost = includeLabor ? area * 8 : 0;
    const subtotal = paintCost + puttyCost + laborCost;
    const gst = Math.round(subtotal * 0.18);
    const grandTotal = subtotal + gst;

    const suggestedCans = {};
    let remaining = paintRequired;
    const canSizes = [20, 10, 4, 1];
    canSizes.forEach((size) => {
      if (remaining >= size) {
        const count = Math.floor(remaining / size);
        suggestedCans[size] = count;
        remaining -= count * size;
      }
    });
    if (remaining > 0) suggestedCans[1] = (suggestedCans[1] || 0) + 1;

    // Logo
    if (companyLogo) {
      doc.addImage(companyLogo, 'PNG', 15, 10, 40, 20);
    }

    // Company Info
    doc.setFontSize(14);
    doc.setFont("helvetica", "bold");
    doc.text("PM Enterprises", 200, 15, { align: "right" });
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.text("B/4 25 Gaytrinagar Chandloadiya 382470 Gujarat", 200, 21, { align: "right" });
    doc.text("GSTIN/UIN: 24ABOPY8217G2Z5", 200, 27, { align: "right" });

    // Title
    doc.setFontSize(16);
    doc.setFont("helvetica", "bold");
    doc.setTextColor(40);
    doc.text("Estimate", 105, 40, { align: "center" });

    // Date & Ref
    doc.setFontSize(10);
    doc.setFont("helvetica", "normal");
    doc.setTextColor(0);
    doc.text(`Date: ${date}`, 15, 50);
    doc.text(`Estimate #: EST-${Date.now().toString().slice(-5)}`, 200, 50, { align: "right" });

    // Project Info
    let y = 60;
    doc.setFontSize(11);
    doc.setFont("helvetica", "bold");
    doc.text("Project Details", 15, y);
    doc.setFont("helvetica", "normal");
    doc.setFontSize(10);
    y += 6;
    doc.text(`• Area: ${area} sq.ft`, 15, y);
    y += 6;
    doc.text(`• Paint: ${selected.name} (${selected.brand}, ${selected.finish})`, 15, y);
    y += 6;
    doc.text(`• Paint Coats: ${paintCoats}`, 15, y);
    y += 6;
    doc.text(`• Putty Coats: ${puttyCoats}`, 15, y);
    y += 6;
    doc.text(`• Labor Included: ${includeLabor ? 'Yes' : 'No'}`, 15, y);

    // Table
    autoTable(doc, {
      startY: y + 10,
      head: [['Item', 'Quantity', 'Rate', 'Amount']],
      body: [
        ['Paint Required', `${paintRequired} L`, rate, paintCost],
        ['Wall Putty', '-', '-', puttyCost],
        ['Labor', '-', '-', laborCost],
        ['Subtotal', '', '', subtotal],
        ['GST (18%)', '', '', gst],
        [{ content: 'Grand Total', colSpan: 3, styles: { fontStyle: 'bold' } }, grandTotal]
      ],
      styles: { fontSize: 10 },
      headStyles: { fillColor: [22, 160, 133], textColor: 255 },
      theme: 'striped'
    });

    const afterTableY = doc.lastAutoTable.finalY;

    // Suggested Can Sizes
    const canText = Object.entries(suggestedCans)
      .map(([size, qty]) => `✔ ${qty} x ${size}L`).join(", ");
    doc.setFontSize(10);
    doc.setFont("helvetica", "bold");
    doc.text("Suggested Can Sizes", 15, afterTableY + 10);
    doc.setFont("helvetica", "normal");
    doc.text(canText, 15, afterTableY + 16);

    // Terms
    doc.setFontSize(9);
    doc.setTextColor(100);
    doc.text("Terms & Conditions:", 15, afterTableY + 30);
    doc.setFontSize(8);
    doc.text([
      "1. This estimate is valid for 15 days.",
      "2. Rates are approximate and may vary based on site conditions.",
      "3. GST is applied as per government norms.",
      "4. Brand-specific paint coverage may vary.",
      "5. Final billing will reflect actual consumption and labor."
    ], 15, afterTableY + 35);

    doc.save("Paint_Estimate.pdf");
  };


  return (
    <>
      <Helmet>
        <title>Paint Budget Calculator | Estimate House Painting Cost in India</title>
        <meta
          name="description"
          content="Easily calculate your home painting budget online. Estimate cost based on paint type, labour, and area. Trusted painting calculator by PM Enterprises India."
        />
        <meta
          name="keywords"
          content="paint calculator India, house painting cost, paint budget estimate, painting price per sqft, wall paint calculator"
        />
        <meta property="og:title" content="Paint Budget Calculator | PM Enterprises" />
        <meta
          property="og:description"
          content="Quickly get your paint budget estimate using our simple online tool. Covers interior, exterior, labour and putty costs. Try it now!"
        />
        <meta property="og:image" content="https://pmpainters.in/assets/paint-budget-meta.jpg" />
        <meta property="og:url" content="https://pmpainters.in/paintcalculator" />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="canonical" href="https://pmpainters.in/paintcalculatort" />
      </Helmet>

      <Box sx={{ position: "relative", minHeight: "100vh", pb: 10 }}>
        <Container
          maxWidth="sm"
          sx={{
            mt: 6,
            backgroundColor: "rgba(255,255,255,0.95)",
            p: 4,
            borderRadius: 3,
            boxShadow: 3,
          }}
        >
          {/* ✅ Heading Animation */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <Typography variant="h4" gutterBottom align="center">
              Paint Budget Calculator
            </Typography>
          </motion.div>

          {/* ✅ Form Animation */}
          <motion.div
            initial={{ opacity: 0, scale: 0.98 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4, delay: 0.2 }}
            viewport={{ once: true }}
          >
            <Grid container spacing={2}>
              {/* Project Type */}
              <Grid item xs={12}>
                <Typography variant="subtitle1">Type of Project:</Typography>
                <RadioGroup
                  row
                  value={projectType}
                  onChange={(e) => {
                    setProjectType(e.target.value);
                    setPaintCoats(e.target.value === "fresh" ? 2 : 1);
                  }}
                >
                  <FormControlLabel value="fresh" control={<Radio />} label="Fresh Painting" />
                  <FormControlLabel value="repainting" control={<Radio />} label="Repainting" />
                </RadioGroup>
              </Grid>

              {/* Space Type */}
              <Grid item xs={12}>
                <Typography variant="subtitle1">Space Type:</Typography>
                <RadioGroup row value={spaceType} onChange={(e) => setSpaceType(e.target.value)}>
                  <FormControlLabel value="interior" control={<Radio />} label="Interior" />
                  <FormControlLabel value="exterior" control={<Radio />} label="Exterior" />
                </RadioGroup>
              </Grid>

              {/* Paint Type */}
              <FormControl fullWidth required>
                <InputLabel id="paint-type-label">Select Paint Type</InputLabel>
                <Select
                  labelId="paint-type-label"
                  fullWidth
                  value={paintType}
                  onChange={(e) => setPaintType(e.target.value)}
                  MenuProps={{ getContentAnchorEl: null }}
                  label="Select Paint Type" // ← ADD THIS LINE
                >
                  {allPaints.map((item) => (
                    <MenuItem key={item._id} value={item.name}>
                      {item.name} (₹{includeLabor ? item.priceWithLabor : item.priceWithoutLabor}/ltr,{" "}
                      {item.estimatedCoverage} sqft/ltr)
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>

              {/* Area */}
              <Grid item xs={12}>
                <TextField
                  label="Total Area (sq. ft.)"
                  type="text"
                  fullWidth
                  value={area}
                  onChange={(e) => setArea((e.target.value))}
                />
              </Grid>

              {/* Coats */}
              <Grid item xs={12}>
                <TextField
                  label="Paint Coats"
                  fullWidth
                  type="number"
                  value={paintCoats}
                  onChange={(e) => setPaintCoats(Number(e.target.value))}
                  helperText="Default: 2 for fresh, 1 for repaint"
                />
              </Grid>

              {/* Putty */}
              <Grid item xs={12}>
                <TextField
                  label="Wall Putty Coats"
                  fullWidth
                  type="number"
                  value={puttyCoats}
                  onChange={(e) => setPuttyCoats(Number(e.target.value))}
                />
              </Grid>

              {/* Labor */}
              <Grid item xs={12}>
                <FormControlLabel
                  control={<Checkbox checked={includeLabor} onChange={(e) => setIncludeLabor(e.target.checked)} />}
                  label="Include Labor Cost"
                />
              </Grid>

              {/* Buttons */}
              <Grid item xs={6}>
                <Button variant="contained" fullWidth onClick={handleCalculate}>
                  Calculate Estimate
                </Button>
              </Grid>
              <Grid item xs={6}>
                <Button
                  variant="outlined"
                  color="secondary"
                  fullWidth
                  onClick={handleReset}
                  disabled={!projectType && !spaceType && !area && !puttyCoats && !includeLabor && !result}
                >
                  Reset
                </Button>
              </Grid>

              {/* ✅ Result Box with Animation */}
              {result && (
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.2, duration: 0.6 }}
                  style={{ width: "100%" }}
                >
                  <Grid item xs={12}>
                    <Box ref={pdfRef} mt={3} p={2} border="1px solid #ccc" borderRadius={2}>
                      <Typography variant="h5" align="center">
                        PM Enterprises
                      </Typography>
                      <Typography align="center">B/4 25 Gaytrinagar Chandloadiya 382470 Gujarat, India</Typography>
                      <Typography align="center">GSTIN: 24ABOPY8217G2Z5</Typography>
                      <Typography align="center" variant="h6" mt={2}>
                        Estimate
                      </Typography>

                      <Typography mt={2}>Paint Required: {result.litres} litres</Typography>
                      <Typography>Paint Cost: ₹{result.paintCost}</Typography>
                      <Typography>Wall Putty Cost: ₹{result.puttyCost}</Typography>
                      <Typography>Labor Cost: ₹{result.laborCost}</Typography>
                      <Typography>GST (18%): ₹{result.gst}</Typography>
                      <Typography>Cost Per Sq.ft: ₹{result.costPerSqft}</Typography>
                      <Typography variant="h6" mt={2}>
                        Total Estimate: ₹{result.grandTotal}
                      </Typography>

                      <Typography mt={2}>
                        <strong>Suggested Can Sizes:</strong>
                      </Typography>
                      {Object.entries(result.suggestedCans).map(([size, count]) => (
                        <Typography key={size}>• {count} x {size}L</Typography>
                      ))}

                      <Typography mt={3} variant="subtitle2">
                        Terms and Conditions:
                      </Typography>
                      <Typography variant="caption">
                        1. Prices are indicative and may vary based on location.<br />
                        2. GST is calculated at 18%.<br />
                        3. Estimate is valid for 15 days from date of generation.<br />
                        4. Labor charges are approximated and may change depending on site condition.
                      </Typography>
                    </Box>
                    <Box mt={2} display="flex" gap={2}>
                      <Button variant="contained" color="primary" size="large">
                        Contact Us
                      </Button>
                      <Button variant="outlined" color="secondary" size="large" onClick={downloadPDF}>
                        Download Estimate
                      </Button>
                    </Box>
                  </Grid>
                </motion.div>
              )}
            </Grid>
          </motion.div>

          {/* Snackbar */}
          <Snackbar
            open={showResetMsg}
            autoHideDuration={3000}
            onClose={() => setShowResetMsg(false)}
            anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
          >
            <Alert onClose={() => setShowResetMsg(false)} severity="success" sx={{ width: "100%" }}>
              Form has been reset successfully!
            </Alert>
          </Snackbar>
        </Container>
      </Box>
    </>

  );
};

export default PaintCalculator;

